export default function Custom404() {
    return (
        <>
        404
        </>
    )
}